import { render, staticRenderFns } from "./customerExclude.vue?vue&type=template&id=dadce642&scoped=true&"
import script from "./customerExclude.vue?vue&type=script&lang=js&"
export * from "./customerExclude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadce642",
  null
  
)

export default component.exports